/**
 * PCExp — tiny client-side split-test assigner.
 *
 * Load AFTER relay.js in layout/theme.liquid:
 *   <script src="{{ 'pc-experiment.js' | asset_url }}" defer></script>
 *
 * Assignment is lazy: a shopper is only enrolled the first time some surface
 * calls PCExp.variant(name). The arm is
 * persisted in localStorage so the shopper keeps it across pages and visits,
 * and reported once to Relay as an experiment_assigned event (retried on later
 * page views until Relay accepts the queue call).
 *
 * Every funnel event a variant-aware surface sends should merge in
 * PCExp.props(name) — {experiment, variant} — so the dashboard can split
 * cohorts without joining back to the assignment event.
 */
(function (window) {
  'use strict';

  if (window.PCExp && window.PCExp.__loaded) { return; }

  var LS_KEY = 'pc_exp_v1';

  /* Active experiments. Remove an entry to retire it — variant() then returns
     null and callers fall back to control behavior. */
  var EXPERIMENTS = {
    /* none active — ai_search_v1 retired 2026-08-27 (AI search rolled out
       to everyone); pdp_popup_v1 retired 2026-08-25 */
  };

  function load() {
    try { return JSON.parse(window.localStorage.getItem(LS_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function save(state) {
    try { window.localStorage.setItem(LS_KEY, JSON.stringify(state)); }
    catch (e) {}
  }

  /* QA override: ?pcexp=ai_search_v1:bar (comma-separate to force several).
     Persists the forced arm with sent:true so no experiment_assigned event
     fires — forced QA visits never pollute the enrollment counts. */
  (function applyForcedArms() {
    try {
      var m = /[?&]pcexp=([^&#]+)/.exec(window.location.search);
      if (!m) { return; }
      var state = load();
      decodeURIComponent(m[1]).split(',').forEach(function (pair) {
        var parts = pair.split(':');
        var arms = EXPERIMENTS[parts[0]];
        if (arms && arms.indexOf(parts[1]) !== -1) {
          state[parts[0]] = { v: parts[1], sent: true };
        }
      });
      save(state);
    } catch (e) {}
  })();

  function reportAssignment(name, arm) {
    if (!(window.Relay && window.Relay.track)) { return false; }
    // Flat props — Relay.track's second argument IS the props object.
    window.Relay.track('experiment_assigned', { experiment: name, variant: arm });
    return true;
  }

  var PCExp = {
    __loaded: true,

    /** The shopper's arm for an experiment ('control' | 'popup' | ...), or null. */
    variant: function (name) {
      var arms = EXPERIMENTS[name];
      if (!arms) { return null; }

      var state = load();
      var entry = state[name];

      if (!entry || arms.indexOf(entry.v) === -1) {
        entry = { v: arms[Math.floor(Math.random() * arms.length)], sent: false };
        state[name] = entry;
        save(state);
      }

      if (!entry.sent && reportAssignment(name, entry.v)) {
        entry.sent = true;
        state[name] = entry;
        save(state);
      }

      return entry.v;
    },

    /** Props to merge into every event from a variant-aware surface. */
    props: function (name) {
      var v = PCExp.variant(name);
      return v ? { experiment: name, variant: v } : {};
    }
  };

  window.PCExp = PCExp;
})(window);
